/* AppearancePreFooter — thin right-aligned widget that sits directly
 * above the footer. Scrolls with the page (not a floating FAB), so it
 * never overlaps LiveChat, Cookie banner, or any other bottom-anchored
 * chrome. Super-responsive: the container centers on mobile, right-
 * aligns on tablet+, and the pill itself shrinks gracefully.
 *
 * Mounted once per page as `<AppearancePreFooter /> <Footer />`.
 */
import React from 'react';
import { AppearanceSettingsButton } from './AppearanceSettings';

export default function AppearancePreFooter() {
  return (
    <div
      className="w-full px-4 sm:px-6 py-4 sm:py-5 flex justify-center sm:justify-end"
      data-testid="appearance-prefooter"
    >
      <AppearanceSettingsButton compact />
    </div>
  );
}
